<div class="section">
  <div class="item-container">
    <div class="label">{{(title1 || '')| translateLang| async}}</div>
    <div class="value">{{(value1 || '')| translateLang| async}}</div>
  </div>
  <div class="item-container">
    <div class="label">{{(title2 || '')| translateLang| async}}</div>
    <div class="value"><bdi>{{(value2 || '')| translateLang| async}}</bdi></div>
  </div>
  <div class="item-container">
    <div class="label">{{(title3 || '')| translateLang| async}}</div>
    <div class = "value" [ngClass]="{'value-3': isSeventhRow === true}"
     (click)="clickHachraza($event)" (keydown.enter)="clickHachraza($event)" [tabindex]="isSeventhRow ? 0 : -1"
    role="button"
     [attr.aria-disabled]="false">{{(value3 || '')| translateLang| async}}
    </div>
  </div>
</div>
